import {action, observable} from 'mobx';
import {scenesType, productType, regionType} from '@/types/APITypes';

/* 支付价格点数据类型 */
export interface priceTypes {
    id: number;
    productType: number;
    productId: productType;
    scenes: scenesType;
    region: regionType;
    title: string;
    subTitle: string;
    subscript: string;
    buyButton: string;
    officialPrice: string;
    realPrice: string;
    period: number;
    beginTime: string;
    endTime: string;
    priority: number;
    status: number;
    createTime: string;
    updateTime: string;
}

class BuyDeviceStore {
  
  @observable priceList: priceTypes [] = []
  
  
  @action.bound async getPriceList () {
  
  }
  
}

export default BuyDeviceStore;
